/*
 * This file is to override some bootstrap's implement as we upgrade from bs3 to bs5 and using tab with radio buttons is gone
 * Most code is from bootstrap's source code, we should delete this file if bs implement the feature in the future
 */


$(function() {
    const getjQuery = () => {
        const {
          jQuery
        } = window;
    
        if (jQuery && !document.body.hasAttribute('data-bs-no-jquery')) {
          return jQuery;
        }
    
        return null;
      };
    
    const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
      const stripNameRegex = /\..*/;
      const stripUidRegex = /::\d+$/;
      const eventRegistry = {}; // Events storage
    
      let uidEvent = 1;
      const customEvents = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
      };
      const customEventsRegex = /^(mouseenter|mouseleave)/i;
      const nativeEvents = new Set(['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll']);
      /**
       * ------------------------------------------------------------------------
       * Private methods
       * ------------------------------------------------------------------------
       */
    
      function getUidEvent(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
      }
    
      function getEvent(element) {
        const uid = getUidEvent(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
      }
    
      function bootstrapHandler(element, fn) {
        return function handler(event) {
          event.delegateTarget = element;
    
          if (handler.oneOff) {
            EventHandler.off(element, event.type, fn);
          }
    
          return fn.apply(element, [event]);
        };
      }
    
      function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
          const domElements = element.querySelectorAll(selector);
    
          for (let {
            target
          } = event; target && target !== this; target = target.parentNode) {
            for (let i = domElements.length; i--;) {
              if (domElements[i] === target) {
                event.delegateTarget = target;
    
                if (handler.oneOff) {
                  // eslint-disable-next-line unicorn/consistent-destructuring
                  EventHandler.off(element, event.type, selector, fn);
                }
    
                return fn.apply(target, [event]);
              }
            }
          } // To please ESLint
    
    
          return null;
        };
      }
    
      function findHandler(events, handler, delegationSelector = null) {
        const uidEventList = Object.keys(events);
    
        for (let i = 0, len = uidEventList.length; i < len; i++) {
          const event = events[uidEventList[i]];
    
          if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
            return event;
          }
        }
    
        return null;
      }
    
      function normalizeParams(originalTypeEvent, handler, delegationFn) {
        const delegation = typeof handler === 'string';
        const originalHandler = delegation ? delegationFn : handler;
        let typeEvent = getTypeEvent(originalTypeEvent);
        const isNative = nativeEvents.has(typeEvent);
    
        if (!isNative) {
          typeEvent = originalTypeEvent;
        }
    
        return [delegation, originalHandler, typeEvent];
      }
    
      function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
        if (typeof originalTypeEvent !== 'string' || !element) {
          return;
        }
    
        if (!handler) {
          handler = delegationFn;
          delegationFn = null;
        } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    
    
        if (customEventsRegex.test(originalTypeEvent)) {
          const wrapFn = fn => {
            return function (event) {
              if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) {
                return fn.call(this, event);
              }
            };
          };
    
          if (delegationFn) {
            delegationFn = wrapFn(delegationFn);
          } else {
            handler = wrapFn(handler);
          }
        }
    
        const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
        const events = getEvent(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);
    
        if (previousFn) {
          previousFn.oneOff = previousFn.oneOff && oneOff;
          return;
        }
    
        const uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
        const fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
        fn.delegationSelector = delegation ? handler : null;
        fn.originalHandler = originalHandler;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, delegation);
      }
    
      function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
    
        if (!fn) {
          return;
        }
    
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
      }
    
      function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        Object.keys(storeElementEvent).forEach(handlerKey => {
          if (handlerKey.includes(namespace)) {
            const event = storeElementEvent[handlerKey];
            removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
          }
        });
      }
    
      function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, '');
        return customEvents[event] || event;
      }
    
    const EventHandler = {
        on(element, event, handler, delegationFn) {
          addHandler(element, event, handler, delegationFn, false);
        },
    
        one(element, event, handler, delegationFn) {
          addHandler(element, event, handler, delegationFn, true);
        },
    
        off(element, originalTypeEvent, handler, delegationFn) {
          if (typeof originalTypeEvent !== 'string' || !element) {
            return;
          }
    
          const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
          const inNamespace = typeEvent !== originalTypeEvent;
          const events = getEvent(element);
          const isNamespace = originalTypeEvent.startsWith('.');
    
          if (typeof originalHandler !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!events || !events[typeEvent]) {
              return;
            }
    
            removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
            return;
          }
    
          if (isNamespace) {
            Object.keys(events).forEach(elementEvent => {
              removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            });
          }
    
          const storeElementEvent = events[typeEvent] || {};
          Object.keys(storeElementEvent).forEach(keyHandlers => {
            const handlerKey = keyHandlers.replace(stripUidRegex, '');
    
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
              const event = storeElementEvent[keyHandlers];
              removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
            }
          });
        },
    
        trigger(element, event, args) {
          if (typeof event !== 'string' || !element) {
            return null;
          }
    
          const $ = getjQuery();
          const typeEvent = getTypeEvent(event);
          const inNamespace = event !== typeEvent;
          const isNative = nativeEvents.has(typeEvent);
          let jQueryEvent;
          let bubbles = true;
          let nativeDispatch = true;
          let defaultPrevented = false;
          let evt = null;
    
          if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
          }
    
          if (isNative) {
            evt = document.createEvent('HTMLEvents');
            evt.initEvent(typeEvent, bubbles, true);
          } else {
            evt = new CustomEvent(event, {
              bubbles,
              cancelable: true
            });
          } // merge custom information in our event
    
    
          if (typeof args !== 'undefined') {
            Object.keys(args).forEach(key => {
              Object.defineProperty(evt, key, {
                get() {
                  return args[key];
                }
    
              });
            });
          }
    
          if (defaultPrevented) {
            evt.preventDefault();
          }
    
          if (nativeDispatch) {
            element.dispatchEvent(evt);
          }
    
          if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
            jQueryEvent.preventDefault();
          }
    
          return evt;
        }
    };
    
    //============================================================================
    const NODE_TEXT = 3;
    const SelectorEngine = {
      find(selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
      },
    
      findOne(selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
      },
    
      children(element, selector) {
        return [].concat(...element.children).filter(child => child.matches(selector));
      },
    
      parents(element, selector) {
        const parents = [];
        let ancestor = element.parentNode;
    
        while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
          if (ancestor.matches(selector)) {
            parents.push(ancestor);
          }
    
          ancestor = ancestor.parentNode;
        }
    
        return parents;
      },
    
      prev(element, selector) {
        let previous = element.previousElementSibling;
    
        while (previous) {
          if (previous.matches(selector)) {
            return [previous];
          }
    
          previous = previous.previousElementSibling;
        }
    
        return [];
      },
    
      next(element, selector) {
        let next = element.nextElementSibling;
    
        while (next) {
          if (next.matches(selector)) {
            return [next];
          }
    
          next = next.nextElementSibling;
        }
    
        return [];
      }
    
    };
    
    
    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
    var EventHandler__default = /*#__PURE__*/_interopDefaultLegacy(EventHandler);
    var SelectorEngine__default = /*#__PURE__*/_interopDefaultLegacy(SelectorEngine);
    
    const getSelector = element => {
        let selector = element.getAttribute('data-bs-target');
    
        if (!selector || selector === '#') {
          let hrefAttr = element.getAttribute('href'); // The only valid content that could double as a selector are IDs or classes,
          // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
          // `document.querySelector` will rightfully complain it is invalid.
          // See https://github.com/twbs/bootstrap/issues/32273
    
          if (!hrefAttr || !hrefAttr.includes('#') && !hrefAttr.startsWith('.')) {
            return null;
          } // Just in case some CMS puts out a full URL with the anchor appended
    
    
          if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
            hrefAttr = `#${hrefAttr.split('#')[1]}`;
          }
    
          selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null;
        }
    
        return selector;
      };
    
    const getElementFromSelector = element => {
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
      };
    
    // const NAME = 'tab';
    const DATA_KEY = 'bs.tab';
    const EVENT_KEY = `.${DATA_KEY}`;
    //   const DATA_API_KEY = '.data-api';
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    //   const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    //   const CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
    const CLASS_NAME_ACTIVE = 'active';
    //   const CLASS_NAME_FADE = 'fade';
    //   const CLASS_NAME_SHOW = 'show';
    //   const SELECTOR_DROPDOWN = '.dropdown';
    const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
    const SELECTOR_ACTIVE = '.active';
    const SELECTOR_ACTIVE_UL = ':scope > li > .active';
    //   const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]';
    //   const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
    //   const SELECTOR_DROPDOWN_ACTIVE_CHILD = ':scope > .dropdown-menu .active';
    
    $.fn.tab.Constructor.prototype.show = function () {
        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(CLASS_NAME_ACTIVE)) {
            return;
        }
    
        let previous;
        const target = getElementFromSelector(this._element);
    
        //Modified place
        let listElement = this._element.closest(SELECTOR_NAV_LIST_GROUP);

        // Modified place
        if (!listElement) {
            listElement = this._element.closest('.btn-group .btn');
            $(listElement).parent().children('.btn-check').prop('checked', false);
            $(listElement).parent().children('.btn').removeClass('active');
        }
    
        if (listElement) {
            const itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
            previous = SelectorEngine__default['default'].find(itemSelector, listElement);
            previous = previous[previous.length - 1];
        }
    
        const hideEvent = previous ? EventHandler__default['default'].trigger(previous, EVENT_HIDE, {
            relatedTarget: this._element
        }) : null;
        const showEvent = EventHandler__default['default'].trigger(this._element, EVENT_SHOW, {
            relatedTarget: previous
        });
    
        if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
            return;
        }
    
        this._activate(this._element, listElement);
    
        const complete = () => {
            EventHandler__default['default'].trigger(previous, EVENT_HIDDEN, {
            relatedTarget: this._element
            });
            EventHandler__default['default'].trigger(this._element, EVENT_SHOWN, {
            relatedTarget: previous
            });
        };
    
        if (target) {
            this._activate(target, target.parentNode, complete);
        } else {
            complete();
        }
    }
});

